module.exports = __webpack_public_path__ + "HelveticaNeue-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/helvetica-neue/HelveticaNeue-Thin.woff
// module id = 47
// module chunks = 51 52